import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaPagination from './VaPagination.vue'

export const VaPagination = withConfigTransport(_VaPagination)
